export const MIXED_TIMEKEEPER_SELECTION_MESSAGE =
	"Select entries for one timekeeper at a time";

type TimekeeperEntryGroup<T> = {
	timekeeperId: string;
	entries: T[];
};

export function groupEntriesByTimekeeper<
	T extends { timekeeperId?: string | null },
>(entries: readonly T[]): TimekeeperEntryGroup<T>[] | false {
	const groups = new Map<string, T[]>();
	for (const entry of entries) {
		const timekeeperId = entry.timekeeperId?.trim();
		if (!timekeeperId) return false;
		const group = groups.get(timekeeperId) ?? [];
		group.push(entry);
		groups.set(timekeeperId, group);
	}
	return Array.from(groups, ([timekeeperId, groupedEntries]) => ({
		timekeeperId,
		entries: groupedEntries,
	}));
}

export function selectionTimekeeperId<
	T extends { timekeeperId?: string | null },
>(entries: T[]): string | null | false {
	const ids = new Set(entries.map((entry) => entry.timekeeperId ?? ""));
	if (ids.size > 1) return false;
	const [id] = ids;
	return id || null;
}
